import React from "react";
import { EntityType } from "../../PhotoManager/API/api";
import { TabType } from "../types";

const peopleIcon = require("../style/people-icon.svg");

interface Person {
  id: number;
  name: string;
  photoCount: number;
  thumbnailImage: string | null;
  type: string;
}

interface PeopleResultsProps {
  people: Person[];
  query: string;
  activeTab: TabType;
  isSingleCategory: boolean;
  highlightSearchTerm: (text: string, searchTerm: string) => React.ReactNode;
  onPersonClick?: (entityType: EntityType, entityId: number, entityName: string) => void;
  setActiveTab: (tab: TabType) => void;
}

const PeopleResults: React.FC<PeopleResultsProps> = ({
  people,
  query,
  activeTab,
  isSingleCategory,
  highlightSearchTerm,
  onPersonClick,
  setActiveTab
}) => {
  if (people.length === 0) return null;

  const handlePersonClick = (person: Person) => {
    if (onPersonClick) {
      onPersonClick("person", person.id, person.name);
    }
  };

  const shouldLimit = activeTab === "all" && !isSingleCategory;
  const displayPeople = shouldLimit ? people.slice(0, 5) : people;
  const showSeeAll = shouldLimit && people.length > 5;

  return (
    <div className="unified-search-section">
      <h2 className="unified-search-section-title">
        <img
          src={peopleIcon}
          alt="People"
          className="unified-search-section-icon"
        />
        People
      </h2>
      <div className="unified-search-people-grid">
        {displayPeople.map(person => (
          <button
            key={person.id}
            type="button"
            className="unified-search-person-card"
            onClick={() => handlePersonClick(person)}
            aria-label={`View ${person.photoCount} ${person.photoCount === 1 ? "photo" : "photos"} of ${person.name}`}
          >
            <div className="unified-search-person-avatar">
              {person.thumbnailImage ? (
                <img
                  src={person.thumbnailImage}
                  alt={person.name}
                  className="unified-search-person-image"
                />
              ) : (
                <div className="unified-search-person-placeholder">
                  {person.name.charAt(0).toUpperCase()}
                </div>
              )}
            </div>
            <div className="unified-search-person-info">
              <div className="unified-search-person-name">
                {highlightSearchTerm(person.name, query)}
              </div>
              <div className="unified-search-person-count">
                {person.photoCount} {person.photoCount === 1 ? "photo" : "photos"}
              </div>
            </div>
          </button>
        ))}
      </div>
      {showSeeAll && (
        <button
          className="unified-search-see-all"
          onClick={() => setActiveTab("people")}
        >
          See all
        </button>
      )}
    </div>
  );
};

export default PeopleResults;
